import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.split";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { updateBairunSvcBalance, findBairunSvcBalance, getBairunSvcBalanceList, updateBairunSvcBalanceStatus, rechargeBairunSvcBalance, creditBairunSvcBalance, creditSvcBalance } from '@/api/bairun/svcBalance';
import { getSvcGroupList } from '@/api/bairun/svcGroup'; //  此处请自行替换地址

import { getBairunPayChannelList } from '@/api/bairun/bairunPayChannel';
import { formatTimeToStr } from '@/utils/date';
import infoList from '@/mixins/infoList';
import SearchTerm from '@/components/searchTerm';
import { mapGetters } from 'vuex';

var _this;

export default {
  name: 'BairunSvcBalance',
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    getOilCodeNames: function getOilCodeNames(oilCodes) {
      var oilCodeArr = oilCodes === '' || !oilCodes ? [] : oilCodes.split(',');
      var oilCodeNames = '';

      if (oilCodeArr.includes('-1')) {
        return '全部油品支持';
      }

      _this.oilCodesOptions.map(function (oil) {
        if (oilCodeArr.includes(oil.value + '')) {
          oilCodeNames += oil.label + ',';
        }
      });

      return oilCodeNames.substr(0, oilCodeNames.length - 1);
    },
    getInvoiceType: function getInvoiceType(oilCodes) {
      var oilCodeArr = oilCodes === '' || !oilCodes ? [] : oilCodes.split(',');
      var oilCodeNames = '';

      if (oilCodeArr.includes('-1')) {
        return '全部油品支持';
      }

      _this.oilCodesOptions.map(function (oil) {
        if (oilCodeArr.includes(oil.value + '')) {
          oilCodeNames += oil.label + ',';
        }
      });

      return oilCodeNames.substr(0, oilCodeNames.length - 1);
    }
  },
  mixins: [infoList],
  computed: _objectSpread(_objectSpread({}, mapGetters('stations', ['allStationMap', 'allStations'])), {}, {
    getRule: function getRule() {
      switch (this.type) {
        case 'add':
          return this.rules;

        case 'update':
          return this.rules;

        case 'recharge':
          return this.rechargeRules;

        case 'credit':
          return this.creditRules;

        case 'addOrReduce':
          return this.creditRules;

        case 'lose':
          return this.loseRules;

        case 'unlose':
          return this.loseRules;

        default:
          break;
      }
    }
  }),
  components: {
    SearchTerm: SearchTerm
  },
  data: function data() {
    return {
      listApi: getBairunSvcBalanceList,
      loading: false,
      searchInfo: {
        // 按配置顺序显示
        'activeStationId': '',
        'svcGroupId': '',
        'mobile': '',
        'svcNumber': '',
        'accountType': '',
        'fullName': '',
        'companyName': '',
        'svcStatus': '',
        'activeDateStart': '',
        'activeDateEnd': ''
      },
      addAndUpdateVisible: false,
      addAndUpdateTitle: '',
      viewVisible: false,
      rechargeVisible: false,
      creditVisible: false,
      addOrReduceVisible: false,
      loseOrCancelVisible: false,
      type: '',
      multipleSelection: [],
      svcAccountTypeOptions: [],
      svcStatusOptions: [],
      svcGroupOptions: [],
      svcConsumeChannelOptions: [],
      payChannelOptions: [],
      creditTypeOptions: [],
      accountTypeOptions: [],
      oilCodesOptions: [],
      oilCodesCheckAll: false,
      oilCodesChecked: [],
      formData: {},
      rules: {
        svcNumber: [{
          required: true,
          message: '请输入储值卡号',
          trigger: 'blur'
        }],
        mobile: [{
          required: true,
          message: '请输入手机号',
          trigger: 'blur'
        }],
        activeStationId: [{
          required: true,
          message: '请选择发卡油站',
          trigger: 'blur'
        }],
        svcGroupId: [{
          required: true,
          message: '请选择卡群组',
          trigger: 'blur'
        }],
        oilCodes: [{
          required: true,
          message: '请选择支持油品',
          trigger: 'blur'
        }],
        payType: [{
          required: true,
          message: '请选择记账',
          trigger: 'blur'
        }],
        svcStatus: [{
          required: true,
          message: '请选择账户状态',
          trigger: 'blur'
        }]
      },
      rechargeRules: {
        rechargeStationId: [{
          required: true,
          message: '请选择充值油站',
          trigger: 'blur'
        }],
        rechargeBalance: [{
          type: 'number',
          required: true,
          message: '请输入正确金额',
          trigger: 'blur',
          min: 0.01
        }],
        rechargePayChannel: [{
          required: true,
          message: '请选择支付方式',
          trigger: 'blur'
        }]
      },
      creditRules: {},
      loseRules: {
        optDescribe: [{
          required: true,
          message: '请输入挂失原因',
          trigger: 'blur'
        }]
      }
    };
  },
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  activated: function activated() {// 使用keepalive的页面,重新展示都会调用

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // 使用keepalive的页面,重新展示不会调用
              _this2.init();

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    init: function init() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var payChannelOptions;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.formData = _this3.initData();
                _context3.next = 3;
                return _this3.getDict('svcAccountType');

              case 3:
                _this3.svcAccountTypeOptions = _context3.sent;
                _context3.next = 6;
                return _this3.getDict('svcStatus');

              case 6:
                _this3.svcStatusOptions = _context3.sent;
                _context3.next = 9;
                return _this3.getDict('svcConsumeChannel');

              case 9:
                _this3.svcConsumeChannelOptions = _context3.sent;
                _context3.next = 12;
                return _this3.getDict('svcCreditType');

              case 12:
                _this3.creditTypeOptions = _context3.sent;
                _context3.next = 15;
                return _this3.getDict('oilCode');

              case 15:
                _this3.oilCodesOptions = _context3.sent;

                if (_this3.allStations && _this3.allStations.length === 1) {
                  _this3.searchInfo.activeStationId = _this3.allStations[0].ID;
                }

                _context3.next = 19;
                return getBairunPayChannelList({
                  page: 1,
                  pageSize: 999999,
                  donNotShowLoading: true
                });

              case 19:
                payChannelOptions = _context3.sent;
                _this3.payChannelOptions = payChannelOptions.data.list.filter(function (item) {
                  return item.supportSource.split(',').includes('admin-recharge') || item.supportSource.split(',').includes('-1');
                });

              case 21:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    initData: function initData() {
      var formdata = {
        accountType: 0,
        activeDate: new Date(),
        activeStationId: '',
        address: '',
        svcGroupId: '',
        balance: 0,
        creditBalance: '',
        reduceBalance: '',
        balanceSum: 0,
        consumeSum: 0,
        fullName: '',
        idCard: '',
        mobile: '',
        isPassword: 1,
        password: '000000',
        preSum: 0,
        returnedSum: 0,
        payLimit: 1,
        payType: 0,
        svcStatus: 0,
        remark: '',
        status: 1,
        subCardNum: 0,
        svcNumber: '',
        virtualVumber: '',
        uid: '',
        consumeChannel: -1,
        oilCodes: '-1',
        optStationId: 0,
        stationId: 0,
        optType: 0,
        optDescribe: ''
      };
      return Object.assign(formdata, this.initRechargeData(), this.initCreditData(), this.initLoseData());
    },
    initRechargeData: function initRechargeData() {
      return {
        rechargeBalance: '',
        rechargeStationId: '',
        rechargePayChannel: '',
        rechargeDescribe: '充值'
      };
    },
    initCreditData: function initCreditData() {
      return {
        creditType: 2,
        creditTypeStr: '',
        creditDescribe: ''
      };
    },
    initAddOrReduceData: function initAddOrReduceData() {
      return {
        creditType: 1,
        reduceType: 1,
        // 1仅扣减余额 2退款
        payChannel: '',
        creditTypeStr: '',
        creditDescribe: ''
      };
    },
    initLoseData: function initLoseData() {
      return {};
    },
    onSearch: function onSearch() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this4.page = 1;
                _this4.pageSize = 10;
                _this4.loading = true;

                _this4.getTableData();

                _this4.loading = false;

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    // 解决input无法输入问题
    inputChange: function inputChange() {
      this.$forceUpdate();
    },
    onSearchSvcGroup: function onSearchSvcGroup(query) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var res;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return getSvcGroupList({
                  groupName: query,
                  page: 1,
                  pageSize: 999999,
                  donNotShowLoading: true
                });

              case 2:
                res = _context5.sent;
                _this5.svcGroupOptions = res.data.list || [];

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    onClose: function onClose() {
      this.addAndUpdateVisible = false;
      this.viewVisible = false;
      this.rechargeVisible = false;
      this.creditVisible = false;
      this.addOrReduceVisible = false;
      this.loseOrCancelVisible = false;
      this.oilCodesChecked = [];
      this.oilCodesCheckAll = false;
      this.formData = this.initData();
    },
    onView: function onView(row) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var that, res;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                that = _this6;
                _context6.next = 3;
                return findBairunSvcBalance({
                  ID: row.ID
                });

              case 3:
                res = _context6.sent;

                if (res.code === 0) {
                  that.formData = res.data.resBairunSvcBalance;

                  if (res.data.resBairunSvcBalance.payType != 5) {
                    that.formData.payType = 0;
                  }

                  that.oilCodesChecked = that.formData.oilCodes === '' ? [] : that.formData.oilCodes === '-1' ? that.oilCodesOptions.map(function (oil) {
                    return oil.value;
                  }) : that.formData.oilCodes.split(',').map(Number);
                  that.oilCodesCheckAll = that.oilCodesChecked.length === that.oilCodesOptions.length;
                  that.type = 'view';
                  that.viewVisible = true;
                }

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    onAdd: function onAdd() {
      var that = this;
      that.type = 'add';
      that.formData = this.initData();
      that.formData.svcStatus = 1;
      that.formData.svcGroupId = 0;
      that.handleCheckAllChange(true);

      if (that.allStations.length > 0) {
        that.formData.activeStationId = that.allStations[0].ID;
      }

      that.addAndUpdateVisible = true;
      that.addAndUpdateTitle = '新增操作';
    },
    onUpdate: function onUpdate(row) {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var that, res;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                that = _this7;
                _context7.next = 3;
                return findBairunSvcBalance({
                  ID: row.ID
                });

              case 3:
                res = _context7.sent;
                that.type = 'update';

                if (res.code === 0) {
                  that.formData = res.data.resBairunSvcBalance;

                  if (res.data.resBairunSvcBalance.payType != 5) {
                    that.formData.payType = 0;
                  }

                  that.oilCodesChecked = that.formData.oilCodes === '' ? [] : that.formData.oilCodes === '-1' ? that.oilCodesOptions.map(function (oil) {
                    return oil.value;
                  }) : that.formData.oilCodes.split(',').map(Number);
                  that.oilCodesCheckAll = that.oilCodesChecked.length === that.oilCodesOptions.length;
                  that.svcGroupOptions = [{
                    groupId: res.data.resBairunSvcBalance.svcGroupId,
                    groupName: res.data.resBairunSvcBalance.svcGroupName
                  }];
                  that.addAndUpdateVisible = true;
                  that.addAndUpdateTitle = '变更操作';
                }

              case 6:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    },
    onLose: function onLose() {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var res, formData;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (!(_this8.multipleSelection.length === 0)) {
                  _context8.next = 3;
                  break;
                }

                _this8.$message({
                  type: 'warning',
                  message: '请选择要操作的数据'
                });

                return _context8.abrupt("return");

              case 3:
                _context8.next = 5;
                return findBairunSvcBalance({
                  ID: _this8.multipleSelection[0].ID
                });

              case 5:
                res = _context8.sent;
                _this8.type = 'lose';

                if (res.code === 0) {
                  formData = res.data.resBairunSvcBalance;
                  _this8.formData = Object.assign(formData, _this8.initLoseData());
                  _this8.loseOrCancelVisible = true;
                }

              case 8:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }))();
    },
    onUnLose: function onUnLose() {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var res, formData;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (!(_this9.multipleSelection.length === 0)) {
                  _context9.next = 3;
                  break;
                }

                _this9.$message({
                  type: 'warning',
                  message: '请选择要操作的数据'
                });

                return _context9.abrupt("return");

              case 3:
                _context9.next = 5;
                return findBairunSvcBalance({
                  ID: _this9.multipleSelection[0].ID
                });

              case 5:
                res = _context9.sent;
                _this9.type = 'unlose';

                if (res.code === 0) {
                  formData = res.data.resBairunSvcBalance;
                  _this9.formData = Object.assign(formData, _this9.initLoseData());
                  _this9.loseOrCancelVisible = true;
                }

              case 8:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }))();
    },
    onAble: function onAble(row) {
      if (row.svcStatus == 1) {
        this.$message({
          type: 'success',
          message: '已开启'
        });
        return;
      }

      this.formData.optType = 12;
      this.formData.optDescribe = '启用';
      this.handleStatus(row.ID, 1);
    },
    onUnAble: function onUnAble(row) {
      if (row.svcStatus == 2) {
        this.$message({
          type: 'success',
          message: '已禁用'
        });
        return;
      }

      this.formData.optType = 13;
      this.formData.optDescribe = '禁用';
      this.handleStatus(row.ID, 2);
    },
    handleStatus: function handleStatus(ID, status) {
      var _this10 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var res;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return updateBairunSvcBalanceStatus({
                  'ID': ID,
                  'svcStatus': status,
                  'optType': _this10.formData.optType,
                  'optDescribe': _this10.formData.optDescribe
                });

              case 2:
                res = _context10.sent;

                _this10.enterDialogRepose(res);

              case 4:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }))();
    },
    onRecharge: function onRecharge() {
      var _this11 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        var res, formData;
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                if (!(_this11.multipleSelection.length === 0)) {
                  _context11.next = 3;
                  break;
                }

                _this11.$message({
                  type: 'warning',
                  message: '请选择要操作的数据'
                });

                return _context11.abrupt("return");

              case 3:
                _context11.next = 5;
                return findBairunSvcBalance({
                  ID: _this11.multipleSelection[0].ID
                });

              case 5:
                res = _context11.sent;

                if (!(res.code === 0)) {
                  _context11.next = 14;
                  break;
                }

                if (!(res.data.resBairunSvcBalance.accountType === 1)) {
                  _context11.next = 10;
                  break;
                }

                _this11.$message({
                  type: 'warning',
                  message: '授权账户不允许充值，只可授钱'
                });

                return _context11.abrupt("return");

              case 10:
                formData = res.data.resBairunSvcBalance;
                _this11.type = 'recharge';
                _this11.rechargeVisible = true;
                _this11.formData = Object.assign(formData, _this11.initCreditData());

              case 14:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }))();
    },
    onCredit: function onCredit() {
      var _this12 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        var res, formData;
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                if (!(_this12.multipleSelection.length === 0)) {
                  _context12.next = 3;
                  break;
                }

                _this12.$message({
                  type: 'warning',
                  message: '请选择要操作的数据'
                });

                return _context12.abrupt("return");

              case 3:
                _context12.next = 5;
                return findBairunSvcBalance({
                  ID: _this12.multipleSelection[0].ID
                });

              case 5:
                res = _context12.sent;
                _this12.type = 'credit';

                if (res.code === 0) {
                  formData = res.data.resBairunSvcBalance;
                  _this12.formData = Object.assign(formData, _this12.initCreditData());
                  _this12.oilCodesChecked = _this12.formData.oilCodes === '' ? [] : _this12.formData.oilCodes === '-1' ? _this12.oilCodesOptions.map(function (oil) {
                    return oil.value;
                  }) : _this12.formData.oilCodes.split(',').map(Number);
                  _this12.oilCodesCheckAll = _this12.oilCodesChecked.length === _this12.oilCodesOptions.length;

                  if (_this12.allStations.length > 0) {
                    _this12.formData.stationId = _this12.allStations[0].ID;
                  }

                  _this12.creditVisible = true;
                }

              case 8:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }))();
    },
    onAddOrReduce: function onAddOrReduce() {
      var _this13 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
        var res, formData;
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                if (!(_this13.multipleSelection.length === 0)) {
                  _context13.next = 3;
                  break;
                }

                _this13.$message({
                  type: 'warning',
                  message: '请选择要操作的数据'
                });

                return _context13.abrupt("return");

              case 3:
                _context13.next = 5;
                return findBairunSvcBalance({
                  ID: _this13.multipleSelection[0].ID
                });

              case 5:
                res = _context13.sent;
                _this13.type = 'addOrReduce';

                if (res.code === 0) {
                  formData = res.data.resBairunSvcBalance;
                  _this13.formData = Object.assign(formData, _this13.initAddOrReduceData());
                  _this13.oilCodesChecked = _this13.formData.oilCodes === '' ? [] : _this13.formData.oilCodes === '-1' ? _this13.oilCodesOptions.map(function (oil) {
                    return oil.value;
                  }) : _this13.formData.oilCodes.split(',').map(Number);
                  _this13.oilCodesCheckAll = _this13.oilCodesChecked.length === _this13.oilCodesOptions.length;

                  if (_this13.allStations.length > 0) {
                    _this13.formData.stationId = _this13.allStations[0].ID;
                  }

                  _this13.addOrReduceVisible = true;
                }

              case 8:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13);
      }))();
    },
    onDiscount: function onDiscount() {},
    onChange: function onChange() {},
    handleCheckAllChange: function handleCheckAllChange(val) {
      this.oilCodesChecked = val ? this.oilCodesOptions.map(function (oil) {
        return oil.value;
      }) : [];
      this.oilCodesCheckAll = this.oilCodesChecked.length === this.oilCodesOptions.length;

      if (this.oilCodesCheckAll) {
        this.formData.oilCodes = '-1';
      } else {
        this.formData.oilCodes = '';
      }
    },
    handleCheckedOilCodesChange: function handleCheckedOilCodesChange(value) {
      this.oilCodesCheckAll = value.length === this.oilCodesOptions.length;

      if (this.oilCodesCheckAll) {
        this.handleCheckAllChange(true);
      } else {
        this.formData.oilCodes = value.join(',');
      }
    },
    onDialogSubmit: function onDialogSubmit() {
      var _this14 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
        var that, paramAdd, param, addOrReduceParam;
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                that = _this14;
                _context14.t0 = _this14.type;
                _context14.next = _context14.t0 === 'add' ? 4 : _context14.t0 === 'update' ? 8 : _context14.t0 === 'recharge' ? 10 : _context14.t0 === 'credit' ? 13 : _context14.t0 === 'addOrReduce' ? 18 : _context14.t0 === 'lose' ? 23 : _context14.t0 === 'unlose' ? 26 : 29;
                break;

              case 4:
                paramAdd = JSON.parse(JSON.stringify(that.formData));
                console.log(paramAdd);
                that.$refs['formData'].validate(function (valid) {
                  if (valid) {
                    creditSvcBalance(paramAdd).then(function (res) {
                      that.enterDialogRepose(res);
                    });
                  } else {
                    return false;
                  }
                });
                return _context14.abrupt("break", 30);

              case 8:
                that.$refs['formData'].validate(function (valid) {
                  if (valid) {
                    updateBairunSvcBalance(that.formData).then(function (res) {
                      that.enterDialogRepose(res);
                    });
                  } else {
                    return false;
                  }
                });
                return _context14.abrupt("break", 30);

              case 10:
                that.formData.optType = 6;
                that.$refs['rechargeFormData'].validate(function (valid) {
                  if (valid) {
                    rechargeBairunSvcBalance(that.formData).then(function (res) {
                      that.enterDialogRepose(res);
                    });
                  } else {
                    return false;
                  }
                });
                return _context14.abrupt("break", 30);

              case 13:
                param = JSON.parse(JSON.stringify(that.formData));
                param.optType = 2;
                param.creditBalance = parseFloat(param.creditBalance);
                that.$refs['creditFormData'].validate(function (valid) {
                  if (valid) {
                    creditBairunSvcBalance(param).then(function (res) {
                      that.enterDialogRepose(res);
                    });
                  } else {
                    return false;
                  }
                });
                return _context14.abrupt("break", 30);

              case 18:
                addOrReduceParam = JSON.parse(JSON.stringify(that.formData));
                addOrReduceParam.optType = 1;
                addOrReduceParam.creditBalance = Math.abs(parseFloat(addOrReduceParam.reduceBalance));
                that.$refs['addOrReduceFormData'].validate(function (valid) {
                  if (valid) {
                    if (addOrReduceParam.stationId == '' || addOrReduceParam.stationId == 0) {
                      _this14.$message({
                        type: 'warning',
                        message: '请选择油站'
                      });

                      return;
                    }

                    if (addOrReduceParam.reduceType == '' || addOrReduceParam.reduceType == 0) {
                      _this14.$message({
                        type: 'warning',
                        message: '请选择扣减类型'
                      });

                      return;
                    }

                    if (addOrReduceParam.reduceType == 2 && (addOrReduceParam.payChannel == '' || addOrReduceParam.payChannel == 0)) {
                      _this14.$message({
                        type: 'warning',
                        message: '请选择付款方式'
                      });

                      return;
                    }

                    if (addOrReduceParam.payChannel == '') {
                      addOrReduceParam.payChannel = 0;
                    }

                    creditBairunSvcBalance(addOrReduceParam).then(function (res) {
                      that.enterDialogRepose(res);
                    });
                  } else {
                    return false;
                  }
                });
                return _context14.abrupt("break", 30);

              case 23:
                that.formData.optType = 10;
                that.$refs['loseFormData'].validate(function (valid) {
                  if (valid) {
                    that.handleStatus(that.formData.ID, 3);
                  } else {
                    return false;
                  }
                });
                return _context14.abrupt("break", 30);

              case 26:
                that.formData.optType = 11;
                that.$refs['loseFormData'].validate(function (valid) {
                  if (valid) {
                    that.handleStatus(that.formData.ID, 1);
                  } else {
                    return false;
                  }
                });
                return _context14.abrupt("break", 30);

              case 29:
                return _context14.abrupt("break", 30);

              case 30:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14);
      }))();
    },
    enterDialogRepose: function enterDialogRepose(res) {
      if (res.code === 0) {
        this.$message({
          type: 'success',
          message: '操作成功'
        });
        this.getTableData();
        this.onClose();
      }
    },
    handleSelChange: function handleSelChange(val) {
      this.multipleSelection = val;
    },
    onClickRow: function onClickRow(row, column, event) {
      this.$refs.svcBalanceTable.toggleRowSelection(row);
    }
  }
};